module.exports = __webpack_public_path__ + "img/basic_principles_of_game_design_splash.9cc75c2c.jpg";